import { styled } from "styled-components";
import { devices } from "../../Constants";

export const TableContainer = styled.div`
	margin-top: 4rem;
	margin-bottom: 2rem;

	header {
		display: block;

		@media only screen and (${devices.lg}) {
			display: grid;
			grid-template-columns: 1fr 1fr;
			margin-top: 1rem;
			gap: 1.3rem;
			align-items: center;

			section {
				display: flex;
				gap: 1.5rem;
			}

			main {
				display: flex;
				justify-content: flex-end;
				gap: 1rem;
			}
		}
	}

	.toolbarSelect {
		.MuiSelect-select {
			color: #333333;
			padding: 6px 18px;
			padding-right: 38px !important;
		}
	}
`;

export const Tags = styled.div`
	display: flex;
	gap: 1rem;
`;

export const Labels = styled.div`
	border-radius: 8px;
	height: ${(props) => (props.size === "small" ? "1rem" : "1.4rem")};
	width: ${(props) => (props.size === "small" ? "1rem" : "1.4rem")};
	background-color: ${(props) =>
		props.type === "Personal"
			? "#F14043"
			: props.type === "Business"
			? "#F8C200"
			: "#31D98C"};
	opacity: 0.5;
`;

export const InformationsWrapper = styled.div`
	border: 1px solid #b8c8cf;
	box-shadow: 0px 0.6rem 3.125rem rgba(0, 103, 112, 0.05);
	border-radius: 0.6rem;
	box-sizing: border-box;
	width: 100%;
	padding: ${(props) => (props.custom ? "2rem 8rem" : "2rem 3rem")};

	.avatar {
		display: flex;
		justify-content: center;
	}
`;

export const ActivityWrapper = styled.div`
	width: 100%;
	background: #f5f5f5;
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	gap: 0.8rem;
	padding: 1rem 1.5rem;
	box-sizing: border-box;
	border-radius: 0.8rem;

	.title {
		font-weight: 600;
	}
`;

export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;

	input[type="file"] {
				color: transparent;
				width: 0;
				height: 0;
				display: none;
			}

	/* .inputText, */
				input,
				textarea,
				select {
					font-weight: 600;
				}

				.inputText {
					width: fit-content;
					word-break: break-word;
					padding-right: 12px;
					/* text-transform: capitalize; */
				}

				.text_view {
					font-size: 17px;
					font-weight: 500;
					padding: 14px;
					border-radius: 5px;
					border: 1px solid #b8c8cf;
					background: #eff8f9;
				}

				input.edit,
				textarea.edit {
					margin-right: 16px;
					padding: 8px 14px;
					border-radius: 6px;
					border: 1px solid #b8c8cf;
				}

	label {
		font-weight: 600;
		font-size: 1rem;
	}

	.fileGroup {
		.viewFileBtn {
			display: flex;
			align-items: center;
			gap: 20px;
			padding: 12px 22px;
			width: fit-content;
			white-space: nowrap;
			border-radius: 6px;
			background: #006770;
			color: #fff;
			font-weight: 500;

			.fileIcon {
				color: #fff;
				font-size: 22px;
			}
			/* span {} */
		}
		.side_btn {
			font-weight: 500;
		}
	}
`;

export const PaymentsButton = styled.button`
	border: 1px solid #dbe3e7;
	border-radius: 0.5rem;
	padding: 0.5rem;
	display: flex;
	gap: 1rem;
`;
